// Vendor
import { type RouteLocationRaw } from "vue-router";

// Constants
import { SALESFORCE_FORM_TYPE } from "@citizenm/salesforce/constants/form";

export default function useSalesforceForm(
  formType: keyof typeof SALESFORCE_FORM_TYPE = "WebToLead",
  thankYouPage?: RouteLocationRaw,
) {
  const { push: pushRoute } = useRouter();

  const state = ref<FormState>("idle");

  async function handleSubmit(values: Record<string, unknown>) {
    state.value = "processing";

    try {
      await $fetch(`/api/salesforce/form/${formType}`, {
        method: "POST",
        body: values,
      });

      state.value = "success";

      if (thankYouPage) {
        pushRoute(thankYouPage);
      }
    } catch (error) {
      state.value = "error";
    }
  }

  return {
    handleSubmit,
    state,
  };
}
